import { useState } from "react";
import axios from "axios";
import { toast } from "sonner";
import { MessageSquare } from "lucide-react";
import { Switch } from "./ui/switch";

const API_URL = process.env.REACT_APP_BACKEND_URL + "/api";

export const SmsConsentToggle = ({ contact, onUpdated, compact = false }) => {
  const [busy, setBusy] = useState(false);
  if (!contact) return null;
  const on = !!contact.sms_consent;
  const optedOut = !!contact.sms_opted_out;

  const toggle = async (next) => {
    setBusy(true);
    try {
      const res = await axios.patch(`${API_URL}/contacts/${contact.id}/sms-consent`, { sms_consent: next });
      onUpdated?.(res.data.contact, res.data.welcome_sms);
      if (next) {
        toast.success(res.data.welcome_sms?.sent ? "Marked OK to text — welcome text sent" : "Marked OK to text");
      } else {
        toast.success("SMS consent removed");
      }
    } catch (e) {
      toast.error(e?.response?.data?.detail || "Failed to update SMS consent");
    }
    setBusy(false);
  };

  return (
    <div
      className={`flex items-center justify-between gap-3 rounded-lg border ${on ? "border-emerald-200 bg-emerald-50" : "border-slate-200 bg-slate-50"} ${compact ? "px-2.5 py-2" : "px-3 py-2.5"}`}
      data-testid="sms-consent-toggle"
    >
      <div className="flex items-center gap-2 min-w-0">
        <MessageSquare className={`w-4 h-4 shrink-0 ${on ? "text-emerald-600" : "text-slate-400"}`} />
        <div className="min-w-0">
          <p className={`${compact ? "text-xs" : "text-sm"} font-medium text-slate-700`}>OK to text</p>
          {!compact && (
            <p className="text-[11px] text-slate-500 truncate" data-testid="sms-consent-status">
              {optedOut ? "Customer replied STOP — texts blocked" : on ? `Consent on file${contact.sms_consent_source ? ` · ${contact.sms_consent_source.split(":")[0].replace(/_/g, " ")}` : ""}` : "Automated texts off until marked OK"}
            </p>
          )}
        </div>
      </div>
      <Switch
        checked={on}
        disabled={busy || !contact.phone}
        onCheckedChange={toggle}
        className="data-[state=checked]:bg-emerald-600"
        data-testid="sms-consent-switch"
      />
    </div>
  );
};

export default SmsConsentToggle;
